<template>
   <div class="wrap common-container">
            <h2 class="public-title">合作流程</h2>
            <div class="cooperate-process">
                <el-row>
                    <el-col :md="4" :sm="4" :xs="6" >
                        <div class="process-list">
                            <img class="process-step" src="@/assets/images/icon/ic_process_no1.png" alt="" >
                            <div class="process-middle">
                                <img class="process-icon" src="@/assets/images/icon/ic_process_brand.png" alt="">
                                <img class="process-arrow" src="@/assets/images/icon/ic_process_arrow.png" alt="">
                            </div>
                            <p class="process-title">品牌支持</p>
                            <div class="process-detail">
                                <p>A.在线申请<br>B.线下联系我们</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :md="1" :sm="1" :xs="1"></el-col>
                    <el-col :md="4" :sm="4" :xs="6" >
                        <div class="process-list">
                            <img class="process-step" src="@/assets/images/icon/ic_process_no2.png" alt="" >
                            <div class="process-middle">
                                <img class="process-icon" src="@/assets/images/icon/ic_process_negotiate.png" alt="">
                                <img class="process-arrow" src="@/assets/images/icon/ic_process_arrow.png" alt="">
                            </div>
                            <p class="process-title">意向洽谈</p>
                            <div class="process-detail">
                                <p>听取初始分析<br>进行资质审核</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :md="1" :sm="1" :xs="1"></el-col>
                    <el-col :md="4" :sm="4" :xs="6" >
                        <div class="process-list">
                            <img class="process-step" src="@/assets/images/icon/ic_process_no3.png" alt="" >
                            <div class="process-middle">
                                <img class="process-icon" src="@/assets/images/icon/ic_process_submittals.png" alt="">
                                <img class="process-arrow" src="@/assets/images/icon/ic_process_arrow.png" alt="">
                            </div>
                            <p class="process-title">递交材料</p>
                            <div class="process-detail">
                                <p>洽谈具体合作细节<br>确定合作意向</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :md="1" :sm="1" :xs="1"></el-col>
                    <el-col :md="4" :sm="4" :xs="6" >
                        <div class="process-list">
                            <img class="process-step" src="@/assets/images/icon/ic_process_no4.png" alt="" >
                            <div class="process-middle">
                                <img class="process-icon" src="@/assets/images/icon/ic_process_authorize.png" alt="">
                                <img class="process-arrow" src="@/assets/images/icon/ic_process_arrow.png" alt="">
                            </div>
                            <p class="process-title">签约授权</p>
                            <div class="process-detail">
                                <p>签订合作协议</p>
                            </div>
                        </div>
                    </el-col>
                    <el-col :md="1" :sm="1" :xs="1"></el-col>
                    <el-col :md="4" :sm="4" :xs="6">
                        <div class="process-list">
                            <img class="process-step" src="@/assets/images/icon/ic_process_no5.png" alt="" >
                            <div class="process-middle">
                                <img class="process-icon" src="@/assets/images/icon/ic_process_start.png" alt="">
                                
                            </div>
                            <p class="process-title">开始运作</p>
                           
                        </div>
                    </el-col>

                    
                </el-row>
            </div>
        </div>
</template>

<script>
import { defineComponent,ref } from 'vue'
export default defineComponent({
 setup(){
     
     return{
        
     }
 }
})
</script>

<style lang="scss" scoped type="text/scss">
.cooperate-process{
    .process-list{
        text-align: center;
    }
    .process-step{
        width:60%;
        max-width:106px;
        // height:48px;
        margin:0 auto;
    }
    .process-icon{
        width:100%;
        max-width:224px;
        // height:224px;
        margin:0 auto;
    }
    .process-title{
        font-size:24px;
        color:#1B1D1F;
        margin-bottom:16px;
    }
    .process-detail{
        display:inline-block;
        text-align: left;
        font-size:16px;
        color:#869099;
    }
    .process-arrow{
        position:absolute;
        left:112.5%;
        top:50%;
        width:32px;
        height:32px;
        margin:-16px 0 0 -16px;
    }
    .process-middle{
        position:relative;
    }
}
</style>
